import FounderBox from './FounderBox';
import hyunwooJoPhoto from '../../assets/images/hyunwoo-jo-photo.jpg'
import richardFuPhoto from '../../assets/images/richard-fu-photo.jpg'
import './FoundersComponent.css'

const FoundersComponent = () => {
  return (
    <div className='founders-box' style={{ marginBottom: '50px' }}>
      <h1 
        style={{
          fontWeight: 700,
          letterSpacing: "-0.02em",
          lineHeight: "1.05",
          fontSize: "clamp(48px, 9vw, 100px)",
          marginBottom: "25px"
        }}>
        Myris Technology Leadership
      </h1>
      <p style={{ fontSize: '20px', marginBottom: '35px'}}>
        Myris Technology’s team combines deep experience in full-stack software, 
        scaled cloud systems, and cyber operations to deliver secure, reliable products for our customers. 
        Our founders set the vision, champion a culture of integrity and execution, 
        and stay hands-on with engineering to keep us fast and customer-focused. 
        We prioritize clear communication, thoughtful design, 
        and measurable outcomes—building solutions that scale from prototype to production. 
        Together, we’re committed to solving hard problems with practical technology that drives real impact.
        </p>
      <hr class="black-divider-h"></hr>
      <div className='founders-box-alignment'>
      <FounderBox
        photo={hyunwooJoPhoto}
        name="Hyunwoo Jo"
        role="Founder & CEO"
        bio="Hyunwoo is a software engineer and entrepreneur with experience in full stack development, cyber operations, and federal contracting. He leads and directs the company's vision."
      />
      <FounderBox
        photo={richardFuPhoto}
        name="Richard Fu"
        role="Co-Founder & CTO"
        bio="Richard is a software engineer and entrepreneur with experience in scaled backend systems. He leads the company’s technical strategy and vision."
      />
      </div>
    </div>
  );
}

export default FoundersComponent;